import React, { useState } from "react";

import Callout from "modules/common/components/callout";
import Loading from "modules/common/components/loading";

import { AudienceUser, AudienceUserSuggestionsV2 } from "../../../models";

import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";

import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";


const SearchUsers: React.FunctionComponent<ComponentProps> = props => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [results, setResults] = useState([] as AudienceUserSuggestionsV2[]);
  const [searchText, setSearchText] = useState("");
  const [showCallout, setShowCallout] = useState(false);

  return (
    <div>
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        value={searchText}
        placeholder="Search users"
        InputProps={{
          startAdornment: <SearchIcon className="search-icon" />
        }}
        onChange={(ev: any) => {
          setSearchText(ev.target.value);
          setAnchorEl(ev.currentTarget);
        }}
        onKeyUp={(key) => {
          if (key.keyCode === 13 && !!searchText) {
            setIsSearching(true);
            setResults([]);
            setShowCallout(true);
            props.onSearch(searchText).then((userSuggestions) => {
              setResults(userSuggestions);
              setIsSearching(false);
            });
          }
        }}
      />
      <Callout
        anchorEl={showCallout ? anchorEl : null}
        open={showCallout}
        setOpen={setShowCallout}
      >
        <div className="audience-search-results-callout">
          {isSearching
            ? <Loading padding={12} />
            : <div>
                {!results.length
                  ? <div className="no-search-results">No users were found</div>
                  : <div className="audience-user-list">
                      {results.map((result) =>
                        <div key={result.id}>
                          <div className="user-suggestion">
                            <div className="user-avatar">
                              <div>{result.name.charAt(0)}</div>
                            </div>
                            <div>
                              <div className="user-name">{result.name}</div>
                              <div className="user-email">{result.email}</div>
                            </div>
                          </div>
                          <div>
                            {result.isIncluded || props.includedUsers.findIndex(user => user.userId === result.id) !== -1
                              ? <IconButton
                                  size="small"
                                  onClick={() => {
                                    props.onRemoveUser(result.id);
                                  }}
                                  className="remove-icon"
                                >
                                  <ClearIcon />
                                </IconButton>
                              : <Button
                                  variant="text"
                                  color="primary"
                                  onClick={() => {
                                    props.onAddUser(result);
                                  }}
                                  className="add-button"
                                >
                                  Add
                                </Button>
                            }
                          </div>
                        </div>
                      )}
                    </div>
                  }
                </div>
            }
          </div>
      </Callout>
    </div>
  );
}

interface ComponentProps {
  amountFetched: number;
  includedUsers: AudienceUser[];
  onAddUser: (user: AudienceUserSuggestionsV2) => void;
  onRemoveUser: (id: string) => void;
  onSearch: (searchText: string) => Promise<AudienceUserSuggestionsV2[]>;
}

export default SearchUsers;